import siteConfig from "./runtime-config";

export const back = "Back";
export const viewEvent = "View Event Details";
export const readMore = "Read More";
export const noArticle = "We are sorry, there are no articles posted";
export const businessHours = "Business Hours";
export const reviewDealership = "Read review about our dealership";
export const noEvent = "No Upcoming Events!";
export const endsOn = "Ends on";
export const aboutTitle = "About US";
export const missionTitle = "Mission Statement";
export const historyTitle = "Our History";
export const ourTeamTitle = "Meet Our Team";
export const profileImagePlaceholder = "https://i.imgur.com/uppKNuF.jpg";
export const viewProfile = "View Profile";
export const phoneNo = "Phone";
export const salesNo = "Sales";
export const serviceNo = "Services";
export const partsServicesSuccess = "Thanks for your submission. We will contact you soon.";
export const tradeInSuccess = "Thanks for your submission. We will contact you soon.";
export const contactUsSuccess = "Thanks for your submission.";
export const contactSellerSuccess = "Thanks for your submission.";
export const requestBrochureSuccess = "Thanks for your submission. We will contact you soon.";
export const inputFormSubmitFailure = "An unexpected issue has occurred. Please contact support";
export const brandCrest = "Crest";
export const brandMasterCraft = "MasterCraft";
export const boatsPageSize = siteConfig["labels-config"].boatsPerPage;
export const formLabel = {
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone",
    message: "Message",
    submit: "Submit",
    partsService: "Parts or Service",
    year: "Year",
    model: "Model",
    family: "Family",
    partDescription: "Part Description",
    preferredAppointment: "Preferred Appointment Time",
    time: "Time",
    additionalInfo: "Additional Info",
    yourInformation: "Your Information",
    streetAddress: "Street Address",
    city: "City",
    state: "State",
    zipcode: "Zip Code",
    country: "Country",
    boatSerial: "Boat Serial",
    make: "Make",
    price: "Price",
    dealer: "Dealer",
    HIN: "HIN",
    Engine: "Engine",
    Tower: "Tower",
    ContactDealer: "Contact Dealer",
    SaltwaterPackage: "Has Saltwater Package"
}
export const usedBoatTitle = "Used Boats";
export const noUsedBoat = "There are currently no used boats listed. Please check out our";
export const newInventory = "New Boats";
export const noNewBoats = "There are no boats matching the current filter selections.";
export const traderInventory = "Browse Inventory";
